import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperCore } from 'swiper/types';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination } from 'swiper';
import { IReviewsProps } from './interface';
import Image from 'next/image';
import { toMonthName } from '../../../lib/common/formatDate';

const Reviews = ({ reviews }: IReviewsProps) => {
  return (
    <>
      <Swiper
        modules={[Pagination]}
        pagination={true}
        slidesPerView={1}
        breakpoints={{
          320: {
            slidesPerView: 1.2,
            spaceBetween: 12,
            slidesPerGroup: 1,
            pagination: {
              el: '.pagination-container-attend',
              bulletClass: 'bg-white',
              clickable: true,
            },
            navigation: {
              nextEl: '.bootcamp-career-next-button',
              prevEl: '.bootcamp-career-prev-button',
              disabledClass: 'disabled_swiper_button',
            },
          },
        }}
        watchOverflow={true}
        observer
        observeParents
        spaceBetween={16}
      >
        {reviews?.map((ele, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="swiper-slide rounded bg-white mb-8">
                <div className="course_box md:p-6 p-4 h-[341px]">
                  <div className="user-header-wrap mb-[11px] flex justify-between border-b border-[#EEEEEE] pb-4">
                    <div className="card-header flex items-center">
                      <div className="uesr-pic w-[38px] h-[38px] md:h-14 md:w-14 rounded-full">
                        <img
                          src={`${process.env.NEXT_PUBLIC_AWS_URI}/${ele.image}`}
                          width="100"
                          height="100"
                          className="rounded-full "
                        />
                      </div>
                      <div className="user-info ml-3">
                        {ele?.name && (
                          <h3 className="md:text-lg text-base font-bold md:leading-22 leading-5 max-w-[150px] h-5 overflow-hidden">
                            {ele.name}
                          </h3>
                        )}
                        {ele?.designation && (
                          <p className="mt-1 md:text-sm text-xs font-regular md:leading-[17px] leading-[14px] max-w-[150px] h-[14px] overflow-hidden">
                            ({ele.designation})
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="qutation-icon h-5 w-5 bg-spriteImg" />
                  </div>
                  <div className="card-body">
                    <div className="card-sub-header mb-4 flex justify-between ">
                      <div className="flex gap-x-[7px]">
                        {ele?.rating > 0 &&
                          [...Array(ele.rating)].map((e, i) => {
                            return (
                              <div className="rate-icon md:h-[17px] md:w-[18px] w-4 h-[14px] bg-spriteImg" key={i} />
                            );
                          })}
                      </div>
                      {ele?.date && (
                        <div className="date-year text-[11px] font-medium leading-4 text-[#666666]">
                          {`${toMonthName(new Date(ele.date).getMonth() + 1)}, ${new Date(ele.date).getFullYear()}`}
                        </div>
                      )}
                    </div>
                    {ele?.review && (
                      <div
                        className="user-Textlimit text-sm font-regular text-black leading-[21px] md:text-xl md:leading-[30px]"
                        dangerouslySetInnerHTML={{ __html: ele.review }}
                      ></div>
                    )}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default Reviews;
